import angular from 'angular';

import causePortalModule from './causePortal';
import coreModule from './core';
import dashboardModule from './dashboard';
import sponsorPortalModule from './sponsorPortal';
import usersModule from './users';

const containers = [
  causePortalModule.name,
  coreModule.name,
  dashboardModule.name,
  sponsorPortalModule.name,
  usersModule.name,
];

export const containersModule = angular.module('app.containers', containers);



// WEBPACK FOOTER //
// ./js/containers/index.js